import { BaseFiltroPagDTO } from "./base-dto";

export class ContatoParmDTO {
  id: number;
  crmCompleto: string;
  cpf: string;
  nome: string;
  email: string;
  celular: string;
  telefone: string;
  nascimento: string;
  nivelHierarquico: string;
  funcao: string;
  observacao: string;
  idsInstituicoes: Array<Number>;
}

export class ContatoFiltrosParmDTO extends BaseFiltroPagDTO {
  textoBusca: string;
}

export class ContatoBuscaPorCampoParmDTO {
  campo: 'NOME' | 'EMAIL' | 'CELULAR' | 'CPF' | 'CRM';
  valor: string;
  idNotIn: number;
}